import React, { useEffect, useRef } from 'react';
import TimelineItem from './TimelineItem';
import { experience } from '../../data/portfolioData';
import { setupScrollAnimations } from '../../utils/animations';
import './Experience.css';

const Experience = () => {
  const timelineRef = useRef(null);

  useEffect(() => {
    const observer = setupScrollAnimations();
    const items = timelineRef.current?.querySelectorAll('.timeline-item');
    items?.forEach(item => {
      if (item) {
        item.style.opacity = '0';
        item.style.transform = 'translateY(40px)';
        observer.observe(item);
      }
    });

    return () => observer.disconnect();
  }, []);

  return (
    <section id="experience">
      <div className="container">
        <div className="section-header">
          <span className="section-badge">MY JOURNEY</span>
          <h2 className="section-title">Professional Experience</h2>
          <p className="section-subtitle">
            5+ years of driving quality excellence across diverse projects in leading organizations.
          </p>
        </div>

        <div className="timeline" ref={timelineRef}>
          {experience.map((item, index) => (
            <TimelineItem
              key={item.id || index}
              date={item.date}
              title={item.title}
              company={item.company}
              description={item.description}
              isLeft={index % 2 === 0}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience;
